export default __webpack_public_path__ + "static/media/commission-icon.67ebc7f4.svg";